module.exports = __webpack_public_path__ + "static/img/news113.29f37f15.png";